import useReveal from '../hooks/useReveal';

const steps = [
  { verb: 'Create', line: 'Start a collection for your event.' },
  { verb: 'Share', line: 'Invite guests with a QR code or link.' },
  { verb: 'Collect', line: 'Everyone adds the photos and videos they took.' },
];

export default function HowItWorks() {
  const [ref, isRevealed] = useReveal();

  return (
    <section className={`how ${isRevealed ? 'is-revealed' : ''}`} ref={ref}>
      <div className="how__header reveal">
        <h2 className="section-title">Everyone captures a different moment.</h2>
        <p className="section-lead">
          ShareShutter brings them all together, from weddings and birthdays to graduations,
          reunions, and every party in between.
        </p>
      </div>

      {/*
        The steps are ordered, but the numerals are not printed. `list-style:
        none` makes VoiceOver drop list semantics in Safari, so the role is
        restated to keep "list, 3 items" being announced.
      */}
      {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
      <ol className="steps reveal" role="list">
        {steps.map((step) => (
          <li className="step" key={step.verb}>
            <h3 className="step__verb">{step.verb}</h3>
            <p className="step__line">{step.line}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
